(ns common.resource.query.feed
  (:require [clojure.string :as str]
            [common.queries.http :as qhttp]))

(defn platform-dynamic-feeds-query [{:keys [advertiser-id] :as path-params}]
  #js {:queryKey #js ["platform-dynamic-feeds" advertiser-id]
       :enabled (some? advertiser-id)
       :queryFn (fn [^js ctx] (qhttp/post (qhttp/render :api/feed-importers-search
                                                        path-params
                                                        {:page (.-pageParam ctx)})
                                          {:body
                                           {:filters [{:field "type"
                                                       :value "lookup"}]
                                            :sort {:direction "desc"
                                                   :field "updated-at"}}}))
       :staleTime (* 60 1000)
       :getNextPageParam (fn [_lastPage pages]
                           (inc (count pages)))})

(defn dynamic-feed-query [{:keys [advertiser-id feed-importer-id] :as path-params}]
  #js {:queryKey #js ["dynamic-feed-query" advertiser-id feed-importer-id]
       :enabled (and (some? advertiser-id) (some? feed-importer-id))
       :queryFn (fn [_] (qhttp/get (qhttp/render :api/feed-importer path-params)))
       :staleTime (* 60 1000)})

(defn unique-values-query
  [{:keys [advertiser-id feed-importer-id column-name] :as path-params}]
  #js {:queryKey #js ["unique-values-query" advertiser-id feed-importer-id column-name]
       :enabled (and (some? advertiser-id)
                     (some? feed-importer-id)
                     (not (str/blank? column-name)))
       :queryFn (fn [_] (qhttp/get (qhttp/render :api/feed-importer-unique-values
                                                 path-params)))
       :staleTime (* 60 1000)})
